import { FC } from "react";

import dynamic from "next/dynamic";

import { MoreButtonsDrawerProps } from "./MoreButtonsDrawerSsr";

export type { CTAProps } from "./MoreButtonsDrawerSsr";

// Disabled SSR to avoid memory leak caused by makeStyles
export const MoreButtonsDrawer = dynamic(
  () => import("./MoreButtonsDrawerSsr").then((mod) => mod.MoreButtonsDrawerSsr),
  {
    ssr: false,
  }
) as FC<MoreButtonsDrawerProps>;
